export class ClientEmployeeRelationshipBO {
    Id: string;
    RelationshipType: string
    type: string
}

export class GetRelationalShipBO {
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string;
    orderType: string = "asc";
    type: string = "string";
    field: string;
    operator: string = "startswith";
    matchCase: boolean = false;
    value: string = "";
    locationID: string | null;
    clientId: string = null;
    employeeId: string;
    relationshipId: string;
    statusLid: string | null;
}

export class saveEmployerEmployeeRelationshipBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    statusLid: string;
    statusName: string;
    clientId: string;
    clientName: string;
    employeeId: string;
    employeeName: string;
    relationshipId: string;
    relationshipName: string;
    relationshipTaxes: EmployerEmployeeRelationshipTaxBO[];
    serviceIds:string[]=[];
    living:boolean = false;
}
export class EmployerEmployeeRelationshipTaxBO {
    taxId: string;
    taxName: string;
    taxable: boolean;
}




